import React from 'react';
import { useShowContext } from 'ui-builder';
import { AbstractTask } from 'nekst-api';

import { DateWithIconWidget } from 'features/nekst-widgets';

export function DueDateField() {

  const showContext = useShowContext<AbstractTask>();

  const data = showContext?.data;

  if (data?.dueDate) {
    return (
      <DateWithIconWidget
        value={data?.dueDate?.date}
        noValueText="No Due Date"
        isApproximate={!!data?.parentTaskRelation}
      />
    )
  } else {
    return null;
  }
}
